import moment from "moment";
import { BaseReq, PaginationReq, PaginationResp, UpdaterResp, FileRecord } from "@/core/interface";
import { getCurrentUserId } from "@/utils";

// 基本信息
export class ApplyInfoReq {
  name: string = `采购申请${moment().format("YYYYMMDDHHmmss")}`; // 采购申请名称
  projectId: string | undefined = undefined; // 所属项目 ID
  applyTenantUserId: string = getCurrentUserId(); // 采购申请人 ID
  applyTime: string = moment().format("YYYY-MM-DD"); // 申请日期
  remark: string = ""; // 摘要
  projectWorkBudgetBizNo: string = ""; // 施工预算编号
  projectWorkBudgetId: string = ""; // 施工预算id
  fileList: FileRecord[]; //附件
}

// 采购明细
export class MaterialRecord extends BaseReq {
  systemName:string="";// 系统名称
  uuid: string = ""; // 唯一ID
  bizNo: string = ""; // 清单编号
  projectWorkBudgetMaterialId: string = ""; // 施工预算清单 ID
  materialId: string = ""; // 材料 ID
  materialNo: string = ""; // 材料编号
  materialName: string = ""; // 材料名称
  materialModel: string = ""; // 规格型号
  materialBrand: string = ""; // 品牌
  materialUnit: string = ""; // 结算单位
  budgetCount: number = 0; // 预算数量
  budgetPrice: number = 0; // 预算单价
  applyCount: number = 0; // 已申请数量
  purchasePoCount: number = 0; // 已采购数量
  currentApplyCount: number = 0; // 本次申请数量
  demandTime: string = moment().format('YYYY-MM-DD'); // 需求日期
  deliveryAddress: string = ""; // 交货地点
  remark: string = ""; // 备注
  source: string = ""; // 预算内（0）外（1）
  sortFiled: number = 1; // 已申请数量
  materialCategoryName: string = ""; // 材料分类名称
  materialCategoryId: string = ""; // 材料分类 ID
  costPrice: number = 0; // 成本价
  salesPrice: number = 0; // 销售价
}

export class ApplyReq extends BaseReq {
  purchaseApplyInfoReq: ApplyInfoReq = new ApplyInfoReq(); // 基本信息
  purchaseApplyDetailReqs: MaterialRecord[] = []; // 采购明细
}

export class ApplyPageReq extends PaginationReq {
  projectName: string | undefined = undefined; // 项目名称
  name: string | undefined = undefined; // 采购申请名称
  startDate: string | undefined = undefined; // 签约开始日期
  endDate: string | undefined = undefined; // 签约结束日期
  applyTenantUserId: string | undefined = undefined; // 签约人
  supplierName: string | undefined = undefined;
  filterNumFlag: string = "1";
  flowStatus: string = "dtj";
  purchaseStatus: string | undefined = undefined;
}

export class ApplyListRecord extends UpdaterResp {
  id: number = 0; // 采购申请ID
  bidNo: string = ""; // 采购申请编号
  name: string = ""; // 采购申请名称
  projectId: string = ""; // 项目 ID
  projectName: string = ""; // 项目名称
  applyTime: string = ""; // 申请日期
  applyTenantUserId: string = ""; // 申请人 ID
  applyTenantUserName: string = ""; // 申请人名称
  validStatus: string = ""; // 生效状态
  validStatusName: string = ""; // 生效状态
  flowStatus: string = ""; // 审批状态Code
  flowStatusName: string = ""; // 审批状态名称
}

export class ApplyPageResp extends PaginationResp<ApplyListRecord> {}

export class ApplySimpleRecord {
  id: string; // 采购申请单 ID
  bizNo: string = ""; // 采购申请单编号
  name: string = ""; // 采购申请名称
  projectId: string = ""; // 项目 ID
}

class DetailResp extends UpdaterResp {
  id: string; // 采购申请单 ID
  bizNo: string = ""; // 采购申请单编号
  projectId: string = ""; // 项目 ID
  projectName: string = ""; // 项目名称
  name: string = ""; // 采购申请名称
  applyTenantUserId: string = ""; // 申请人 ID
  applyTenantUserName: string = ""; // 申请人名称
  applyTime: string = ""; // 申请日期
  partyBCooperationCompanyId: string = "";
  type: number = 0;
  remark: string = ""; // 摘要
  validStatus: string = ""; // 生效状态
  validStatusName: string = ""; // 生效状态
  flowStatus: string = ""; // 审批状态Code
  flowStatusName: string = ""; // 审批状态名称
  projectWorkBudgetBizNo: string = ""; // 施工预算编码
  projectWorkBudgetId: string; // 施工预算id
}

export class ApplyDetailResp {
  purchaseApplyResp: DetailResp = new DetailResp();
  purchaseApplyDetailResps: MaterialRecord[] = [];
  name: string = "";
}

export class MaterialPageReq extends PaginationReq {
  id: string = ""; // 采购申请单 ID
  materialName: string = ""; // 材料名称

  constructor(id) {
    super();
    this.id = id;
  }
}

export class MaterialPageResp extends PaginationResp<MaterialRecord> {
  materialId: string = "";
  budgetCount: number = 0;
  budgetPrice: number = 0;
}
